module.exports = __webpack_public_path__ + "img/main3.0db58069.png";